module.exports = __webpack_public_path__ + "img/no-items-calendar.6a6e1fbc.svg";